import { render, staticRenderFns } from "./CreateVersion.vue?vue&type=template&id=4e3269a7&"
import script from "./CreateVersion.vue?vue&type=script&lang=js&"
export * from "./CreateVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports